import React from "react"
import { useLocation, Link } from "react-router-dom"

const SuccessPage = () => {
  const location = useLocation()
  const { orderId } = location.state || {}

  return (
    <div style={{ textAlign: "center", padding: "30px" }}>
      <h2>🎉 Payment Successful!</h2>
      {orderId && (
        <p>
          Your Order ID: <strong>{orderId}</strong>
        </p>
      )}
      <Link to="/">
        <button style={{ marginTop: "20px" }}>Back to Home</button>
      </Link>
    </div>
  )
}

export default SuccessPage
